<template>
  <div>
    <p>
      Legen Sie zuerst die teilnehmenden Klassenstufen (Jahrgangsstufen) fest. Wählen Sie dazu die Klassenstufe aus
      und tragen dahinter die Teilnehmerzahl in dieser Stufe ein. Bitte beachten Sie, dass wir Erst- und Zweitklässer
      zu den Drittklässlern dazurechnen, da es für diese keine eigene Wertung gibt und sie in Jahrgangsstufe 3
      gewertet werden.
    </p>
    <h6>Bitte beachten Sie die Mindestteilnehmerzahlen:</h6>
    <p>
      Eine teilnehmende Klassenstufe: mindestens 10 Teilnehmer*innen insgesamt<br/>
      Zwei teilnehmende Klassenstufen: mindestens 20 Teilnehmer*innen insgesamt<br/>
      Drei teilnehmende Klassenstufen: mindestens 30 Teilnehmer*innen insgesamt<br/>
      Für jede weitere Klassenstufe: mindestens 5 weitere Teilnehmer*innen<br/>
    </p>
    <p>
      Bitte schauen Sie bei Unklarheiten bezüglich der Mindestteilnehmerzahl auf unsere Regelseite auf den
      Abschnitt Mindestteilnehmerzahl – dort gibt es Beispiele
    </p>

    <b-alert variant="danger" :show="this.minimum && this.getActualCount < this.minimum">
      Sie müssen mindestens {{this.minimum}} Kinder anmelden
    </b-alert>

    <class-list :classes=classes v-on:update=update></class-list>

    <b-row class="mt-5">
      <b-col>
        <b-button type="button" variant="secondary" v-on:click="$emit('back')">abbrechen</b-button>
      </b-col>
      <b-col class="text-right">
        <b-button type="button" variant="danger" v-if="registrationId && this.classes.length === 0 && this.minimum === 0" v-on:click="deleteRegistration">
          Anmeldung löschen
        </b-button>

        <b-button type="button" variant="primary" v-else v-on:click=next :disabled=buttonDisabled>
          weiter
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ClassList from '@/components/competitions/registration/ClassList'

export default {
  name: 'CompetitionRegistrationClasses',
  props: ['classes', 'minimum', 'registrationId'],

  components: {
    ClassList
  },

  computed: {
    buttonDisabled () {
      const current = this.getActualCount
      return !!(current <= 0 || (this.minimum && current < this.minimum))
    },

    isValid () {
      if (this.getActualCount < this.getRequiredCount) {
        return false
      }

      return true
    },

    getActualCount () {
      let count = 0
      this.classes.each((registeredClass) => {
        count += registeredClass.count
      })

      return count
    },

    getRequiredCount () {
      if (this.classes.length === 0) {
        return 10
      }

      if (this.classes.length <= 3) {
        return this.classes.length * 10
      }

      return 30 + (this.classes.length - 3) * 5
    }
  },

  methods: {
    update (registeredClasses) {
      this.$emit('update', registeredClasses)
    },

    deleteRegistration () {
      this.$eventHub.$emit(
        'confirm',
        'Wollen Sie die Anmeldung wirklich löschen?',
        'Löschen bestätigen',
        () => {
          this.axios.delete('registrations/' + this.registrationId)
            .then(() => {
              this.$router.replace({
                name: 'teacher.dashboard',
                params: {'alert': {'variant': 'info', 'message': 'Anmeldung erfolgreich gelöscht'}}
              })
            })
            .catch((err) => { this.$eventHub.$emit('error', err) })
        }
      )
    },

    next () {
      if (!this.isValid) {
        this.$eventHub.$emit(
          'alertError',
          'Sie haben momentan ' + this.classes.length + ' Klassenstufen angemeldet. In diesem Fall müssen Sie mindestens' +
          ' ' + this.getRequiredCount + ' Kinder insgesamt anmelden.'
        )

        return
      }

      this.$parent.next()
    },

    cancel () {
      this.$router.push({name: 'teacher.dashboard'})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/competitions/registration/Classes.vue